import { render, staticRenderFns } from "./PointPanel.vue?vue&type=template&id=7bd2fdb2&scoped=true&"
import script from "./PointPanel.vue?vue&type=script&lang=js&"
export * from "./PointPanel.vue?vue&type=script&lang=js&"
import style0 from "./PointPanel.vue?vue&type=style&index=0&id=7bd2fdb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd2fdb2",
  null
  
)

export default component.exports